import type { AlphaEyeKeyLevelCategory } from '@thinkalpha/platform-ws-client/contracts/widget/alpha-eye.js';

export type SetActiveCategoriesAction = {
    type: 'SET_ACTIVE_CATEGORIES';
    value: ReadonlySet<AlphaEyeKeyLevelCategory> | null;
};
export const setActiveCategories = (
    value: ReadonlySet<AlphaEyeKeyLevelCategory> | null,
): SetActiveCategoriesAction => ({
    type: 'SET_ACTIVE_CATEGORIES',
    value,
});

export type KeyLevelsAction = SetActiveCategoriesAction;
